// @ts-ignore
import React, { FC, useMemo } from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { create } from 'zustand';
import fetchQuery from './fetchQuery';

const network = Network.create((request, variables, cacheConfig, uploadables) => {
    return fetchQuery(request, variables, uploadables);
}, undefined);

const source = new RecordSource();
const store = new Store(source, { gcReleaseBufferSize: 10 });

const environment = new Environment({
    network,
    store
});

export default environment;

type RelayStore = {
    isRelayStoreDirty: boolean;
    relayStoreKey: number;
    invalidateRelayStore: () => void;
    incrementRelayStoreKey: () => void;
};

export const useRelayStore = create<RelayStore>((set, get) => ({
    isRelayStoreDirty: false,
    relayStoreKey: 0,
    incrementRelayStoreKey: () => {
        set({ relayStoreKey: get().relayStoreKey + 1, isRelayStoreDirty: false });
    },
    invalidateRelayStore: () => {
        set({ isRelayStoreDirty: true });
    }
}));

export const Relay: FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const storeKey = useRelayStore((state) => state.relayStoreKey);

    const environment = useMemo(() => {
        const source = new RecordSource();
        const store = new Store(source, { gcReleaseBufferSize: 10 });

        return new Environment({
            network,
            store
        });
    }, [storeKey]);

    return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>;
};
